//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.InspectionByIdWithMediaUrlQuery_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.InspectionByIdWithMediaUrlQuery_VariablesAdapter
import com.wintermar.inspection.graphql.selections.InspectionByIdWithMediaUrlQuerySelections
import com.wintermar.inspection.graphql.type.FindingCategory
import com.wintermar.inspection.graphql.type.GetInspectionByIdWithMediaUrlQueryInput
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import com.wintermar.inspection.graphql.type.InspectionStatus
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.collections.List
import com.wintermar.inspection.graphql.type.Query as CompiledQuery

public data class InspectionByIdWithMediaUrlQuery(
  public val `param`: GetInspectionByIdWithMediaUrlQueryInput,
) : Query<InspectionByIdWithMediaUrlQuery.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    InspectionByIdWithMediaUrlQuery_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = InspectionByIdWithMediaUrlQuery_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledQuery.type
  )
  .selections(selections = InspectionByIdWithMediaUrlQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(InspectionByIdWithMediaUrlQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val inspectionByIdWithMediaUrl: InspectionByIdWithMediaUrl,
  ) : Query.Data

  public data class InspectionByIdWithMediaUrl(
    public val id: Any,
    public val status: InspectionStatus,
    public val lastUpdatedAt: Any?,
    public val templateId: Any,
    public val conductedAt: Any,
    public val template: Template,
  )

  public data class Template(
    public val id: Any,
    public val name: String,
    public val version: Int,
    public val publishedDate: Any?,
    public val parentId: Any?,
    public val numberOfPages: Int?,
    public val numberOfSections: Int?,
    public val numberOfQuestions: Int?,
    public val pages: List<Page>,
  )

  public data class Page(
    public val id: Any,
    public val templateId: Any,
    public val order: Int,
    public val title: String,
    public val sections: List<Section>,
  )

  public data class Section(
    public val id: Any,
    public val pageId: Any,
    public val order: Int,
    public val title: String,
    public val questions: List<Question>,
  )

  public data class Question(
    public val id: Any,
    public val sectionId: Any,
    public val questionText: String,
    public val guidelines: String?,
    public val required: Boolean,
    public val order: Int,
    public val answerType: InspectionAnswerType,
    public val failedOptionId: Any?,
    public val neutralOptionId: Any?,
    public val answers: Answers?,
  )

  public data class Answers(
    public val id: Any,
    public val inspectionId: Any,
    public val questionId: Any,
    public val optionId: Any?,
    public val answer: String?,
    public val displayAnswer: String?,
    public val notes: String?,
    public val findingCategory: FindingCategory?,
    public val media: List<Medium>?,
    public val lastUpdatedAt: Any?,
  )

  public data class Medium(
    public val id: Any,
    public val fileName: String,
    public val originalFileName: String,
    public val size: Int,
    public val fileUploaded: Boolean?,
    public val fileUrl: String?,
    public val thumbnailUrl: String?,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "e372afe41c74561b72a6ad215599c2839069ceb289cb03dd453f91364e57a2bb"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query inspectionByIdWithMediaUrl($param: GetInspectionByIdWithMediaUrlQueryInput!) {
     *   inspectionByIdWithMediaUrl(query: $param) {
     *     id
     *     status
     *     lastUpdatedAt
     *     templateId
     *     conductedAt
     *     template {
     *       id
     *       name
     *       version
     *       publishedDate
     *       parentId
     *       numberOfPages
     *       numberOfSections
     *       numberOfQuestions
     *       pages {
     *         id
     *         templateId
     *         order
     *         title
     *         sections {
     *           id
     *           pageId
     *           order
     *           title
     *           questions {
     *             id
     *             sectionId
     *             questionText
     *             guidelines
     *             required
     *             order
     *             answerType
     *             failedOptionId
     *             neutralOptionId
     *             answers {
     *               id
     *               inspectionId
     *               questionId
     *               optionId
     *               answer
     *               displayAnswer
     *               notes
     *               findingCategory
     *               media {
     *                 id
     *                 fileName
     *                 originalFileName
     *                 size
     *                 fileUploaded
     *                 fileUrl
     *                 thumbnailUrl
     *               }
     *               lastUpdatedAt
     *             }
     *           }
     *         }
     *       }
     *     }
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query inspectionByIdWithMediaUrl(${'$'}param: GetInspectionByIdWithMediaUrlQueryInput!) { inspectionByIdWithMediaUrl(query: ${'$'}param) { id status lastUpdatedAt templateId conductedAt template { id name version publishedDate parentId numberOfPages numberOfSections numberOfQuestions pages { id templateId order title sections { id pageId order title questions { id sectionId questionText guidelines required order answerType failedOptionId neutralOptionId answers { id inspectionId questionId optionId answer displayAnswer notes findingCategory media { id fileName originalFileName size fileUploaded fileUrl thumbnailUrl } lastUpdatedAt } } } } } } }"

    public const val OPERATION_NAME: String = "inspectionByIdWithMediaUrl"
  }
}
